<template>
  <div>
    <gs-modal
      v-loading="loading"
      v-model="visible"
      :before-close="beforeClose"
      :has-form="true"
      title="程序的下载"
      width="50%"
      class="my-test-class"
      @cancel="close"
      @confirm="handleConfirm"
    >
        <uploader
          browse_button="browse_button"
          url="https://welink-iot.com/proxy/manage-object/program/downLoad"
          chunk_size="2MB"
          :multi_selection="false"
          :filters="{prevent_duplicates:true}"
          :FilesAdded="filesAdded"
          :BeforeUpload="beforeUpload"
          @inputUploader="inputUploader"
        />
        <el-button type="primary" id="browse_button" size="small" v-show="fileBtShow">选择一个文件</el-button>
        <br/>
        <el-table
          :data="tableData"
          style="width: 95%; margin: 10px 10px;">
          <el-table-column
            width="120"
            label="文件名">
            <template slot-scope="scope">
              <span>{{scope.row.name}}</span>
            </template>
          </el-table-column>
          <el-table-column
            width="80"
            label="大小">
            <template slot-scope="scope">
              <span>{{scope.row.size}}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status === -1">正在计算MD5</span>
              <span v-if="scope.row.status === 1">MD5计算完成，准备上传</span>
              <span v-if="scope.row.status === 4" style="color: brown">上传失败</span>
              <span v-if="scope.row.status === 5" style="color: chartreuse">已上传</span>
              <el-progress v-if="scope.row.status === 2" :text-inside="true" :stroke-width="20" :percentage="scope.row.percent"></el-progress>
            </template>
          </el-table-column>
          <el-table-column
            width="150"
            label="操作">
            <template slot-scope="scope">
              <el-button size="small" type="danger" @click="deleteFile(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <br/>
        <el-button type="danger" size="small"  @click="up.start()">开始上传</el-button>
       <el-button  size="small"  @click="selectOrder">选择程序</el-button>
    </gs-modal>


    <gs-modal
      v-loading="loading"
      v-model="visible1"
      :before-close="beforeCloseOrder"
      :has-form="true"
      top="10%"
      title="场景端控制应用程序库"
      width="80%"
      min-height= "800px"
      class="my-test-class"
      @cancel="closeOrder"
      @confirm="handleConfirmOrder"
    >
      <div style="width: 100%;height: 540px;">
        <div style="width: 100%;height: 70%;background-color: #10152c;overflow: hidden">
          <el-row :gutter="20" type="flex"  style="min-height: 80%;margin-top: 2.5%">
            <el-col :span="7">
              <div style="text-align: center;width: 100%;height: 100%;display: flex;align-items: center;justify-content: center">
                <div><span style="font-size: 2vh;color: white;font-weight: 800">核心程序</span></div>
              </div>
            </el-col>
            <el-col :span="3">
              <div style="width: 100%;height: 100%;background-color: white">
              </div>
            </el-col>
            <el-col :span="3">
              <div style="width: 100%;height: 100%;background-color: white">
              </div>
            </el-col>
            <el-col :span="3">
              <div style="width: 100%;height: 100%;background-color: white">
              </div>
            </el-col>
            <el-col :span="3">
              <div style="width: 100%;height: 100%;background-color: white">
              </div>
            </el-col>
            <el-col :span="3">
              <div style="width: 100%;height: 100%;background-color: white">
              </div>
            </el-col>
          </el-row>
        </div>
        <div style="width: 100%;height: 70%;background-color: #10152c;overflow: hidden;margin-top: 2%">
          <el-row :gutter="20" type="flex"  style="min-height: 80%;margin-top: 2.5%">
            <el-col :span="7">
              <div style="text-align: center;width: 100%;height: 100%;display: flex;align-items: center;justify-content: center">
                <div><span style="font-size: 2vh;color: white;font-weight: 800">一般程序</span></div>
              </div>
            </el-col>
            <el-col :span="3">
              <div style="width: 100%;height: 100%;background-color: white">
              </div>
            </el-col>
            <el-col :span="3">
              <div style="width: 100%;height: 100%;background-color: white">
              </div>
            </el-col>
            <el-col :span="3">
              <div style="width: 100%;height: 100%;background-color: white">
              </div>
            </el-col>
            <el-col :span="3">
              <div style="width: 100%;height: 100%;background-color: white">
              </div>
            </el-col>
            <el-col :span="3">
              <div style="width: 100%;height: 100%;background-color: white">
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </gs-modal>

  </div>
</template>
<script>
  import { mapState, mapMutations, mapActions } from 'vuex'
  import service from '../../service/leftService.js'
  import FileMd5 from '../../models/file-md5.js'
  import Uploader from './Uploader'
  export default {
    data () {
      return {
        visible1:false,
        fileBtShow:true,
        up: {},
        files:[],
        tableData: [],
        percentage: 100,
        loading: false,
      }
    },
    components: {
      'uploader': Uploader
    },
    created () {

    },
    computed: {
      ...mapState({
        visible: 'orderDialogShow',
        nodeData: 'objectInfo'
      })
    },
    watch: {
      files: {
        handler(event) {
          this.tableData = [];
          this.files.forEach((e) => {
            this.tableData.push({
              name: e.name,
              size: e.size,
              status: e.status,
              id: e.id,
              percent: e.percent
            });
          });
        },
        deep: true
      },
      visible () {
        this.getData()
      },
      'tableData':function (val) {
        if(this.tableData.length === 0){
          this.fileBtShow = true
        }else{
          this.fileBtShow = false
        }
      }
    },
    beforeMount () {

    },
    methods: {
      ...mapMutations({
        close: 'ORDER_DIALOG_HIDE',
        needReload: 'NEED_RELOAD_TREE'
      }),
      handleConfirmOrder(){
        this.visible1 = false
      },
      closeOrder(){
        this.visible1 = false
      },
      beforeCloseOrder(){
        this.visible1 = false
      },
      selectOrder(){
        this.visible1 = true
      },
      inputUploader(up) {
        this.up = up;
        this.files = up.files;
      },
      filesAdded(up, files) {
        files.forEach((f) => {
          f.status = -1;
          FileMd5(f.getNative(), (e, md5) => {
            f["md5"] = md5;
            f.status = 1;
          });
        });
      },
      deleteFile(id) {
        let file = this.up.getFile(id);
        this.up.removeFile(file);
      },
      beforeUpload(up, file) {
        up.setOption("multipart_params", {"size":file.size,"md5":file.md5,"id":this.nodeData.id});
      },
      handleConfirm () {
        // if (this.nodeData.id && this.nodeData.type === 'device') {
        //   let param = {
        //     id: this.nodeData.id,
        //     'name': this.name,
        //     'type': 'device',
        //     value: this.nodeData.value,
        //     'parentId': this.nodeData.parentId,
        //     'description': this.description,
        //     'attribute': this.form // 其他信息这里，键值对形式
        //   }
        //   service.renamePoint(param).then(res => {
        //     if (res.code) {
        //       this.$Message.error(res.message)
        //       this.loading = false
        //     } else {
        //       this.loading = false
        //       this.$Message.success('修改成功')
        //       this.close()
        //       this.needReload()
        //     }
        //   })
        // } else {
        // let param = {
        //   'name': this.name,
        //   'type': 'device',
        //   'parentId': this.nodeData.id,
        //   'description': this.description,
        //   'attribute': this.form // 其他信息这里，键值对形式
        // }
        /*let filePath = '/home/ubuntu/aim/program/app.bin';*/
        if(this.selection.length == 0){
          this.$Message.error('请选择下载路径')
        } else {
          let filePath = this.selection[0].path;
          service.orderDown(this.nodeData.id, filePath).then(res => {
            this.loading = false
            this.$Message.success('下载成功')
            //this.$store.state.addTreeNode = res
            this.close()
          }).catch(err => {
            this.loading = false
            this.$Message.error(err.message)
          })

        }

        /*this.selection.forEach(e => {
          for (let i in e) {
            if (!e[i]) {
              delete e[i]
            }
          }
        })
        service.saveDevices(this.selection).then(res => {
          this.loading = false
          this.$Message.success('添加成功')
          this.$store.state.addTreeNode = res
          this.close()
        }).catch(err => {
          this.loading = false
          this.$Message.error(err.message)
        })*/
        // }
      },
      beforeClose () {
        this.close()
      },
      getData () {
       /* this.tableData=[];*/
       /* service.orderDownList().then(res => {
          this.tableData = res
        })*/
        /*service.searchDevice(this.din, this.ip).then(res => {
          this.tableData = res
        })
        console.log(this.tableData)*/
      },
      search () {
        this.getData()
      },
      getSelections (selection) {
        if(selection.length>1){
          this.$refs.selectionTable.clearSelection()
          this.$refs.selectionTable.toggleRowSelection(selection.pop())
        }else{
          this.selection=selection
        }
      },
      handleRowClick(row,column,event){
        this.$refs.selectionTable.toggleRowSelection(row)
      },
      // 进度条
      customColorMethod(percentage) {
        if (percentage < 30) {
          return '#909399';
        } else if (percentage < 70) {
          return '#e6a23c';
        } else {
          return '#67c23a';
        }
      },
      increase() {
        this.percentage += 10;
        if (this.percentage > 100) {
          this.percentage = 100;
        }
      },
      decrease() {
        this.percentage -= 10;
        if (this.percentage < 0) {
          this.percentage = 0;
        }
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/deviceAbout/orderDevice.vue